
/* Utils */
import {getBrowserCookie} from '../../../client/common/persistence/browserCookieUtils'
import {decodeJwt} from '../../common/jwt/jwtUtils'

/* Constants */
import {
  USER_INFO_JWT_TOKEN_COOKIE_NAME,
  USER_INFO_COOKIE_NAME,
  HBUS_ANONYMOUS_ID_COOKIE_NAME
} from './accountConstants'

function createUserInfo(rawUserInfo) {
  return {
    gender: rawUserInfo.Gender || null,
    firstName: rawUserInfo?.fn || rawUserInfo.FirstName || null,
    lastName: rawUserInfo?.ln || rawUserInfo.LastName || null,
    isAuthenticated: isAuth(rawUserInfo?.exp) || rawUserInfo.IsAuthenticated === 'True',
    email: rawUserInfo?.e || rawUserInfo.Email || null,
    userId: rawUserInfo?.uid || rawUserInfo.UserId || null,
    sessionId: rawUserInfo.SessionId || null,
  }
}

const isAuth = (exp) => {
  const currentTime = Math.floor(Date.now() / 1000)
  return exp > currentTime
}

function getUserInfoJwtToken(req) {
  let jwtToken;

  if (process.env.BROWSER) {
    jwtToken = getBrowserCookie(USER_INFO_JWT_TOKEN_COOKIE_NAME);
  } else if (req) {
    jwtToken = req.cookies[USER_INFO_JWT_TOKEN_COOKIE_NAME];
  } else {
    jwtToken = null;
  }

  return jwtToken;
}

function getUserInfoCookie(req) {
  let jwtToken;

  if (process.env.BROWSER) {
    jwtToken = getBrowserCookie(USER_INFO_COOKIE_NAME);
  } else if (req) {
    jwtToken = req.cookies[USER_INFO_COOKIE_NAME];
  } else {
    jwtToken = null;
  }

  return jwtToken;
}

function getAnonymousIdHbusToken(req) {
  let hbusToken;

  if (process.env.BROWSER) {
    hbusToken = getBrowserCookie(HBUS_ANONYMOUS_ID_COOKIE_NAME);
  } else if (req) {
    hbusToken = req.cookies[HBUS_ANONYMOUS_ID_COOKIE_NAME];
  } else {
    hbusToken = null;
  }

  return hbusToken;
}

function extractCachedUserInfoJwt(req) {
  let cachedUserInfo;

  const jwt = getUserInfoJwtToken(req);
  const userInfoWithJwt = jwt ? createUserInfo(decodeJwt(jwt)) : null;


  const anonymousId = getAnonymousIdHbusToken(req);
  let userInfoWithAnonymousId = {
    ...userInfoWithJwt || {},
    userId: anonymousId,
  };

  if (userInfoWithJwt && userInfoWithJwt.isAuthenticated) {
    cachedUserInfo = userInfoWithJwt;
  } else if (userInfoWithAnonymousId) {
    cachedUserInfo = userInfoWithAnonymousId;
  } else {
    cachedUserInfo = null;
  }

  return cachedUserInfo;
}

function extractCachedUserInfoCookie(req) {
  let cachedUserInfo;

  const userInfoCookie = getUserInfoCookie(req);
  const userInfo = userInfoCookie ? createUserInfo(userInfoCookie ? JSON.parse(userInfoCookie) : {}) : null

  const anonymousId = getAnonymousIdHbusToken(req);
  let userInfoWithAnonymousId = {
    ...userInfo || {},
    userId: anonymousId,
  };

  if (userInfo && userInfo.isAuthenticated) {
    cachedUserInfo = userInfo;
  } else if (userInfoWithAnonymousId) {
    cachedUserInfo = userInfoWithAnonymousId;
  } else {
    cachedUserInfo = null;
  }

  return cachedUserInfo;
}

export {
  extractCachedUserInfoJwt,
  extractCachedUserInfoCookie,
  createUserInfo,
  getUserInfoJwtToken,
};
